<template>
  <section>
    <form action v-on:submit.prevent="moveDocument">
      <div class="modal-card">
        <header class="modal-card-head">
          <p>Seleccionar Carpeta de destino</p>
        </header>
        <section class="modal-card-body">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <b-field label="Seleccionar Carpeta">
            <b-select
              placeholder="Seleccionar carpeta de destino"
              v-model="directory_id"
              expanded
              required
            >
              <option
                v-for="option in listDirectories"
                :value="option.id"
                :key="option.id"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">
            Cerrar
          </button>
          <button class="button is-primary" type="submit">Guardar</button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
// import { getDirectoriesFindByCellar } from "../../../services/directory";
// import { updateDocument } from "../../../services/document";
import { DirectoryService } from '../../../services/models/directory';
import { DocumentService } from '../../../services/models/document';
import {eventBus} from "./../../../main";

export default {
  props: ["checkedRows","chargeDocumentList"],
  data() {
    return {
      isLoading: false,
      listDirectories: [],
      directory_id: null,
    };
  },
  mounted() {
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.isLoading = true;
      const {data : directories} = await DirectoryService.getDirectoriesFindByCellar(this.$route.params.id);
      this.listDirectories = directories;
      // this.listDirectories = await getDirectoriesFindByCellar(this.$http,this.$route.params.id);
      this.isLoading = false;
    },
    async moveDocument() {
      this.isLoading = true;
      for (let i = 0; i < this.checkedRows.length; i++) {
        let data = {
          ...this.checkedRows[i],
          state_directory: "Con Directorio",
          directory_id: this.directory_id,
        };
        try {
          await DocumentService.update(this.checkedRows[i].id, data);          
          this.$buefy.notification.open({
            message: `Documento N°${this.checkedRows[i].number} movido a carpeta sin problemas`,
            type: "is-success",
            autoClose:true,
            duration:2000,
          });
          eventBus.$emit('loadDirectories');
        } catch (error) {
          this.$buefy.notification.open({
            message: `Ocurrio un error con el documento N°${this.checkedRows[i].number}, no pudo moverse`,
            type: "is-danger",
          });
        } 
      }
        this.chargeDocumentList();
        (this.isLoading = false), this.$parent.close();
      //   await updateDocument(this.$http, this.checkedRows[i].id, data).then(
      //     (response) => {
      //       if (response) {
      //         this.$buefy.notification.open({
      //           message: `Documento N°${this.checkedRows[i].number} movido a carpeta sin problemas`,
      //           type: "is-success",
      //           autoClose:true,
      //           duration:2000,
      //         });
      //       } else {
      //         this.$buefy.notification.open({
      //           message: `Ocurrio un error con el documento N°${this.checkedRows[i].number}, no pudo moverse`,
      //           type: "is-danger",
      //         });
      //       }
      //     }
      //   );
      // }
      // this.chargeDocumentList();
      // (this.isLoading = false), this.$parent.close();
    },
  },
};
</script>